




// ===================== Store Users Longitude/Latitude ====================== \\
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export function getStoredLocation() {
    const raw = localStorage.getItem('userLocation');

    if (!raw) return null;

    const parsed = JSON.parse(raw);

    const isExpired = (Date.now() - parsed.timestamp) > ONE_DAY_MS;

    return isExpired ? null : parsed;
}
export function requestAndStoreLocation() {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const location = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    timestamp: Date.now()
                };

                localStorage.setItem(
                    'userLocation',
                    JSON.stringify(location)
                );

                resolve(location);
            },
            reject
        );
    });
}
// =========================================================================== \\



// Gets location object --> Properties: [city, location, region, lat, lng, timestamp]
// ===================== Store Users IP Address Location ===================== \\
export async function getStoredApproxLocation() {
    const raw = localStorage.getItem('approxLocation');

    if (!raw) return null;

    const parsed = JSON.parse(raw);

    const isExpired = (Date.now() - parsed.timestamp) > ONE_DAY_MS;

    return isExpired ? null : parsed;
}

export async function requestAndStoreApproxLocation() {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();

    const location = {
        city: data.city,
        region: data.region_code || data.region,
        regionName: data.region,
        country: data.country_code || data.country,
        countryName: data.country_name,
        lat: data.latitude,
        lng: data.longitude,
        timestamp: Date.now()
    };

    localStorage.setItem(
        'approxLocation',
        JSON.stringify(location)
    );

    return location;
}
// =========================================================================== \\
